<template>
  <div>
    <vx-card class="mt-3">
      <vs-table
        :sst="true"
        @search="handleSearch"
        :data="vesselGroups"
        v-model="selected"
        @sort="handleSort"
        @change-page="handleChangePage"
        pagination
        max-items="10"
        search
      >
        <template slot="header">
          <vs-button
            style="margin-left:5px;margin-top:5px"
            icon-pack="feather"
            icon="icon-plus"
            @click="popupActive=true"
          >Add vessel group</vs-button>
        </template>
        <template slot="thead">
          <vs-th sort-key="id">No.</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="icon_type">Icon type</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">{{ indextr +1 }}</vs-td>
            <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
            <vs-td :data="data[indextr].icon_type">{{ data[indextr].icon_type }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-button v-if="selected!=''" color="danger" class="m-3" @click="openConfirm()">Delete</vs-button>
      <vs-button v-if="selected!=''" color="warning" class="m-3" @click="edit()">Edit</vs-button>
    </vx-card>
    <!------------popup add --------->
    <div>
      <div class="demo-alignment">
        <vs-popup classContent="popup-example" title="Add Vessel Groups" :active.sync="popupActive">
          <vs-input
            v-model="theVesselGroups.name"
            class="w-full mb-3"
            label-placeholder="Name"
            placeholder="Name"
          />
          <vs-textarea
            v-model="theVesselGroups.mmsi_list"
            class="w-full mb-3"
            label-placeholder="MMSI_LIST"
            placeholder="MMSI_LIST"
            style="background-color: white;border: 1px solid rgba(0, 0, 0, 0.2);"
          />
          <vs-input
            v-model="theVesselGroups.icon_type"
            class="w-full mb-3"
            label-placeholder="Icon Type"
            placeholder="Icon Type"
          />
          <vs-button color="primary" class="w-full" type="filled" @click="insert()">Save</vs-button>
        </vs-popup>
      </div>
    </div>
    <!------------popup edit --------->
    <div>
      <div class="demo-alignment">
        <vs-popup
          :active.sync="popupActive2"
          classContent="popup-example"
          title="Edit Vessel Groups"
        >
          <vs-input
            v-model="editVesselGroup.name"
            class="w-full mb-3"
            label-placeholder="Name"
            placeholder="Name"
          />
          <vs-textarea
            v-model="editVesselGroup.mmsi_list"
            class="w-full mb-3"
            label-placeholder="MMSI_LIST"
            placeholder="MMSI_LIST"
            style="background-color: white;border: 1px solid rgba(0, 0, 0, 0.2);"
          />
          <vs-input
            v-model="editVesselGroup.icon_type"
            class="w-full mb-3"
            label-placeholder="Icon Type"
            placeholder="Icon Type"
          />
          <vs-button color="primary" class="w-full" type="filled" @click="update()">update</vs-button>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/gmap/gmaps";
import { database } from "firebase";
import { API_BASE_URL } from '@/constants'

// import { lstat } from "fs";

export default {
  data() {
    return {
      theVesselGroups: {
        name: "",
        mmsi_list: "",
        icon_type: ""
      },
      editVesselGroup: {
        name: "",
        mmsi_list: "",
        icon_type: ""
      },
      vesselGroups: this.$store.state.vesselGroupsData,
      selected: [],
      selectedVessel: [],
      popupActive: false,
      popupActive2: false,
      excisemmsiList: "",
      excisemmsiListDetail: [],
      accessEmail: "",
      accessToken: "",
      statusSearch: true,
      countdataExcise: 0
    };
  },
  mounted() {
    this.$vs.loading();
    this.$store.dispatch("updateTitlePage", "Vessel group");
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.getVesselGroups();
  },
  watch: {
    selected(val) {
      this.excisemmsiListDetail = [];

      this.getdataExciseTanker(val.id);
    },
    excisemmsiListDetail() {
      for (let i = 0; i < this.excisemmsiListDetail.length; i++) {
        this.excisemmsiListDetail[i].index = i;
      }
    }
  },
  methods: {
    getVesselGroups() {
      axios
        .get(`${API_BASE_URL}/admin/vessel_groups.json`, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.vesselGroups = response.data;
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },
    async getdataExciseTanker(id) {
      await axios
        .get(`${API_BASE_URL}/admin/vessel_groups/${id}.json`, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          console.log("respose data", response.data.mmsi_list);
          this.excisemmsiList = response.data.mmsi_list;
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });

      this.convertmmsiList();
    },

    convertmmsiList() {
      var ar = this.excisemmsiList.split(",");
      for (let i = 0; i < ar.length; i++) {
        this.fineExciseTankerList(ar[i]);
      }
    },
    fineExciseTankerList(mmsi) {
      this.countdataExcise = this.countdataExcise + 1;
      if (this.countdataExcise == this.excisemmsiListDetail.length) {
        this.statusSearch == false;
      }
      axios
        .get(`${API_BASE_URL}/admin/vessels.json`, {
          params: {
            "q[mmsi_or_imei_or_imo_number_or_imn_number_or_radio_channel_or_name_or_ship_class_or_vendor_id_or_call_sign_or_reg_number_or_color_or_description_or_other_com_ch_or_owner_name_or_owner_address_or_owner_phone_or_master_name_or_master_address_or_master_phone_cont]": mmsi,
            "q[is_visible_true]": 1
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.excisemmsiListDetail.push(response.data[0]);
        })
        .catch(error => {
          console.log("vessel list API error:", error);
        });
    },
    insert() {
      axios
        .post(`${API_BASE_URL}/admin/vessel_groups.json`, this.theVesselGroups, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          console.log("insert vesselgroup ok", response.data);
          this.vesselGroups.unshift(response.data);
          this.popupActive = false;
        })
        .catch(error => {
          console.log("not found vesselgroup", error);
          this.popupActive = true;
        });
    },
    edit() {
      // this.editVesselGroup = this.selected;
      let routeData = this.$router.resolve({ name: "editVesselGroup" });
      window.open(routeData.href, "_parent");
      localStorage.setItem("idVesselGroup", this.selected.id);
    },
    update() {
      this.$vs.loading();
      axios
        .put(
          `${API_BASE_URL}/admin/vessel_groups/${this.selected.id}.json`,
          this.editVesselGroup,
          {
            headers: {
              "X-User-Email": "api@excise-online.com",
              "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
            }
          }
        )
        .then(response => {
          let indexOfVesselGroup = this.vesselGroups.indexOf(this.selected);
          this.vesselGroups.splice(indexOfVesselGroup, 1, this.editVesselGroup);
          this.$vs.loading.close();
          this.excisemmsiListDetail = [];
          this.getdataExciseTanker(this.selected.id);
          console.log("update ok", response.data);
          this.popupActive2 = false;
        })
        .catch(error => {
          console.log("update not found", error);
          this.$vs.loading.close();
          this.popupActive2 = true;
        });
    },
    openConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `ยืนยันการลบข้อมูล`,
        text:
          "Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups.",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.delete();
    },
    delete() {
      axios
        .delete(`${API_BASE_URL}/admin/vessel_groups/${this.selected.id}.json`, {
          headers: {
            "X-User-Email": "api@excise-online.com",
            "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
          }
        })
        .then(response => {
          let indexOfVesselGroup = this.vesselGroups.indexOf(this.selected);
          this.vesselGroups.splice(indexOfVesselGroup, 1);
          this.$vs.notify({
            title: "ลบข้อมูลสำเร็จ",
            text: "Lorem ipsum dolor sit amet, consectetur",
            color: "success"
          });
          console.log("delete vessel group ok", response, data);
        })
        .catch(error => {
          console.log("not found delete", error);
        });
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleChangePage(page) {
      console.log(`The user changed the page to: ${page}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    }
  }
};
</script>
<style>
</style>